import React, { PropsWithChildren } from 'react';
import { makeStyles } from 'tss-react/mui';
import { CssBaseDecorator } from '../cssbasedecorator';

import './layout.scss';

const typographyOverride = {
  DefaultFontSize: 12,
};

const dimensionsOverride = {
  DefaultGridSpacing: 1,
  ThemeSpacingUnit: 4,
};

const useStyles = makeStyles()(() =>
  ({
    embeddedContent: {
      padding: `${dimensionsOverride.ThemeSpacingUnit * 2}px`,
    },
  })
);

export function EmbeddedLayout(props: PropsWithChildren<{}>) {
  const { children } = props;
  const { classes } = useStyles();

  return (
    <CssBaseDecorator overrides={{ dimensionsOverride, typographyOverride }}>
      <div className="embedded-layout__container">
        <div className={classes.embeddedContent}>{children}</div>
      </div>
    </CssBaseDecorator>
  );
}
